import React, { Component } from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom'
import Graphiql from './Graphiql';

import './App.css';

class App extends Component {
  render() {
    return (
      <Router>
        <div style={{ height: '100%' }}>
           <Route exact path="/simple/v1/:projectIdOrAlias" component={Graphiql}/>
           <Route exact path="/relay/v1/:projectIdOrAlias" component={Graphiql}/>
         </div>
       </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js